import axios from 'axios';
import { apiGrossPayrollBaseUrl, apiCreateRequest, apiGetApprovalWorkflowsType } from 'config';

import { encryptPayload } from './encrypt_decrypt';

export const checkWorkflow = async (token, type, businessMember, metaData) => {
    // Check workflow type --> Make API call to get workflow by type
    const res = await axios.get(`${apiGrossPayrollBaseUrl}${apiGetApprovalWorkflowsType}/${type}`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    if (res?.data?.error === false) {
        const workflow = await res?.data?.data;
        // Create approval request
        const requestPayload = {
            workflowId: workflow?.id,
            initiatorId: businessMember?._id,
            employerId: businessMember?.employerId,
            type: workflow?.type,
            metaData: metaData
        }
        const response = await createApprovalRequest(requestPayload, token);
        return { workflowExist: true, data: response }
    } else {
        return { workflowExist: false, data: null }
    }
}

export const createApprovalRequest = async (payload, token) => {
    const encryptedPayload = await encryptPayload(payload);

    const res = await axios.post(`${apiGrossPayrollBaseUrl}${apiCreateRequest}`, encryptedPayload , {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    if (res?.data?.error === false) {
        return res?.data;
    }
}